<span class="mat-select-error">
  <ng-content></ng-content>
</span>
